import { getServerPublicApiKey } from "./env";
import { encryptAnswers, UnencryptedAnswers } from "./types/form/submission/answer";
import { encrypt, PlainString } from "./types/json/crypto";
import { encryptSecretSubmissionDataKeyByLink, LinkEncryptedSecretSubmissionDataKey, PlainSecretSubmissionDataKey, PublicApiKey, PublicSubmissionDataKey, PublicSubmissionLinkKey } from "./types/keys";

export async function encryptSubmitAnswers(publicKey: PublicApiKey, obj: UnencryptedAnswers) {
  if (!publicKey) {
    throw new Error("Key not loaded");
  }

  return await encryptAnswers(publicKey, obj);
}

export async function encryptObject(publicKey: PublicSubmissionDataKey, obj: UnencryptedAnswers) {
  if (!publicKey) {
    throw new Error("Key not loaded");
  }

  return await encryptAnswers(publicKey, obj);
}

export async function encryptString(publicKey: PublicSubmissionDataKey, string: PlainString) {
  if (publicKey) {
    return encrypt(publicKey, string);
  } else {
    return null;
  }
}

export interface EncryptSubmissionKeypairForLinkProps {
  linkPublicKey: PublicSubmissionLinkKey,
}
export async function encryptSubmissionKeyForLink(submission: EncryptSubmissionKeypairForLinkProps, plain: PlainSecretSubmissionDataKey): Promise<LinkEncryptedSecretSubmissionDataKey> {
  const serverApiKeypair = await getServerPublicApiKey();
  const encrypted = encryptSecretSubmissionDataKeyByLink(serverApiKeypair, submission.linkPublicKey, plain);
  return encrypted;
}
